import type { LlmModel } from '@saaga/shared/interfaces/llm-model.interface'
import { CheckIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { CommandEmpty, CommandGroup, CommandItem, CommandList } from '@/components/ui/command'
import { cn } from '@/lib/utils'

export interface ModelSelectorCommandContentProps {
  modelList: LlmModel[]
  selectedValue: string
  onSelect: (value: string) => void
}

export const ModelSelectorCommandContent = ({
  modelList,
  selectedValue,
  onSelect,
}: ModelSelectorCommandContentProps): ReactNode => {
  return (
    <CommandList className="model-selector-searchable-list">
      <CommandEmpty>No models found.</CommandEmpty>
      <CommandGroup>
        {modelList.map((model) => (
          <CommandItem
            key={model.id}
            value={model.id}
            onSelect={onSelect}
            className="model-selector-searchable-item"
          >
            <div className="flex flex-col">
              <span className="font-medium">{model.name}</span>
              <span className="text-xs text-muted-foreground">{model.id}</span>
            </div>
            <CheckIcon
              className={cn(
                'ml-auto size-4',
                selectedValue === model.id ? 'opacity-100' : 'opacity-0'
              )}
            />
          </CommandItem>
        ))}
      </CommandGroup>
    </CommandList>
  )
}

ModelSelectorCommandContent.displayName = 'ModelSelectorCommandContent'
